import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import getSetCookie from '../../../cookie';
import { debounce, setDataAttr } from '../../../utils/helper';
import './TopNavBar.scss';

class TopNavBar extends PureComponent {
    static propTypes = {
        topNavData: PropTypes.object
    };
    constructor(props) {
        super(props);
        this.isScrolled = false;
        this.state = {
            headerScroll: false
        };
        this.handleScroll = debounce(this.handleScroll.bind(this), 100);
        this.handleWidget = this.handleWidget.bind(this);
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll() {
        const scrollTop = window.pageYOffset;
        if (scrollTop > 35) {
            this.setState({ headerScroll: true });
        } else {
            this.setState({ headerScroll: false });
        }
    }
    handleWidget() {
        const { redisCommonData, userInfo } = this.props;
        if (redisCommonData?.ENABLE_FRESHWORKS_DESKTOP === 'ON') {
            const iframe = document.getElementById('launcher-frame');
            let iframeDocument;
            if (iframe) {
                iframeDocument = iframe.contentWindow.document;
                const launcher = iframeDocument.querySelector('.launcher-button');
                if (launcher) {
                    launcher.click();
                }
            }
        } else {
            const { chatBotParams } = window;
            chatBotParams.emailId = userInfo?.result?.email || '';
            chatBotParams.phoneNumber = userInfo?.result?.telephone || '';
            chatBotParams.sessionID = getSetCookie.getCookie('frontend') || '';
            chatBotParams.env = process.env.BUILD_ENV === 'development' ? 'preprod' : 'prod';
            chatBotParams.apiClient = process.env.CLIENT_TYPE;
            window.Freshbots?.reloadContext();
            window.setTimeout(() => {
                window.Freshbots?.initiateChat();
                window.Freshbots?.showWidget(true);
            }, 1000);
        }
    }
    render() {
        const { topNavData, isSupported, dataLocale: { CONTACT_US } } = this.props;
        return (
            <div className="container-fluid">
                <div className="headeTopWrapper">
                    <nav aria-label="Useful links" className={`topNav_bar is-${this.state.headerScroll ? 'scroll' : 'no-scroll'}`}>
                        <ul className="display-flex">
                            {topNavData.topBarNavLeft && topNavData.topBarNavLeft.map((item, index) => {
                                const dataAttr = item.gaObj && Object.keys(item.gaObj).length > 0 ? setDataAttr(item.gaObj) : null;
                                if (item.url && (item.url.indexOf('http') > -1)) {
                                    const hrefUrl = item.url && item.url.indexOf('compare-looks') > -1 ? new URL(item.url) : item.url;
                                    return (
                                        <li key={item.label + index} className="menuItem">
                                            <a
                                                {...dataAttr}
                                                className="getGaData"
                                                href={hrefUrl.pathname ? hrefUrl.pathname : hrefUrl}
                                                title={item.label}
                                                onClick={() => {
                                                    // evt.preventDefault();
                                                    window.sessionStorage.setItem('previousChannel', window.dtm.channel);
                                                    if (item.url && item.url.indexOf('compare-looks') > -1) {
                                                        localStorage.setItem('dittoCompare', window.location.href);
                                                    }
                                                    if (window.dtm.LenskartRewamp) {
                                                        window.dtm.LenskartRewamp.header.click.headerClick(this.props.section, item.label, this.props.loginStatus);
                                                    }
                                                    window.location.href = item.url;
                                                }}
                                                target="_self"
                                            >
                                                {item.label}
                                            </a>
                                        </li>
                                    );
                                } else if (item.facetime) {
                                    return (
                                        <li key={item.label + index}>
                                            <a
                                                href={`tel:${item.facetime}`}
                                                {...dataAttr}
                                                className="getGaData"
                                                onClick={evt => {
                                                    evt.preventDefault();
                                                    if (window.dtm.LenskartRewamp) {
                                                        window.dtm.LenskartRewamp.header.click.headerClick(this.props.section, item.label, this.props.loginStatus);
                                                    }
                                                    window.location.href = `tel:${item.facetime}`;
                                                }}
                                            >
                                                {item.label}
                                            </a>
                                        </li>
                                    );
                                }
                                return (
                                    <li key={item.label + index} className="menuItem">
                                        {item.url && (isSupported || !(item.url.indexOf('compare-looks') !== -1)) ? (
                                            <Link
                                                to={item.url}
                                                className="getGaData"
                                                {...dataAttr}
                                                onClick={() => {
                                                    window.sessionStorage.setItem('previousChannel', window.dtm.channel);
                                                    if (item.url && item.url.indexOf('compare-looks') > -1) {
                                                        localStorage.setItem('dittoCompare', window.location.href);
                                                    }
                                                    if (window.dtm.LenskartRewamp) {
                                                        window.dtm.LenskartRewamp.header.click.headerClick(this.props.section, item.label, this.props.loginStatus);
                                                    }
                                                }}
                                            >
                                                {item.label}
                                            </Link>
                                        ) : ''}
                                    </li>);
                            })}
                        </ul>
                    </nav>
                    <nav aria-label="Useful links" className="topRight">
                        <ul className="display-flex">
                            {/* topNavData.topBarNavRight && topNavData.topBarNavRight.map(item => {
                            return (
                                <a
                                    className="topRightLink"
                                    href={item.url}
                                    title={item.label}
                                    key={item.label}
                                    onClick={() => {
                                        window.sessionStorage.setItem('previousChannel', window.dtm.channel);
                                        if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.header.click.headerClick(this.props.section, item.label, this.props.loginStatus);
                                    }}
                                >
                                    <i className={`${item.iconClass} topIcon`}></i>
                                    <span className="topSpan">{item.label}</span>
                                </a>
                            );
                        }) */}
                            <li className="topRightLink cursor-pointer" onClick={this.handleWidget}>{CONTACT_US}</li>
                        </ul>
                    </nav>
                </div>
            </div>
        );
    }
}

TopNavBar.defaultProps = {
    topNavData: {}
};

export default TopNavBar;
